import { render, staticRenderFns } from "./NewRequestEndorsement.vue?vue&type=template&id=0315df8c"
import script from "./NewRequestEndorsement.vue?vue&type=script&lang=js"
export * from "./NewRequestEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports